module.exports = __webpack_public_path__ + "img/b6.c09eb2d1.jpg";